import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService, LoadingState } from '../../../services/shared/loading/loading.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-global-loading',
    templateUrl: './global-loading.component.html',
    styleUrls: ['./global-loading.component.css'],
    standalone: false
})
export class GlobalLoadingComponent implements OnInit, OnDestroy {
  loadingState: LoadingState = {
    isLoading: false,
    activeRequests: 0
  };
  private destroy$ = new Subject<void>();

  constructor(
    private loadingService: LoadingService,
    private router: Router
  ) {}

  get isAdminRoute(): boolean {
    return this.router.url.startsWith('/admin');
  }

  ngOnInit(): void {
    this.loadingService.loadingState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.loadingState = state;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}